module.exports = __webpack_public_path__ + "img/ergoname-dark.029b663f.png";